var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('slices-slideshow',_vm._g({staticClass:"passage-slideshow",attrs:{"slices":_vm.doc.data.body},on:{"end":_vm.goToNextSection}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }